import { render, staticRenderFns } from "./srvTime2Line.vue?vue&type=template&id=1936a1e6&scoped=true&"
import script from "./srvTime2Line.vue?vue&type=script&lang=js&"
export * from "./srvTime2Line.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1936a1e6",
  null
  
)

export default component.exports